export default __webpack_public_path__ + "static/accents-role-do-99df073de77623024ad91acdcb475505.png";